<template>
	<v-card outlined
		style = "
			width  		: 100%; 
			height 		: 100%; 
			object-fit 	: fill; 
			overflow-x 	: hidden; 
			overflow-y 	: hidden; 
			min-width  	: 200px;" 
		ref   = "card"
	>
		<v-card-title
			class = "body-1 secondary pa-0 pl-2 vue-draggable-handle white--text"

		>
			<span 
				v-text = "$ml.get('analytics')"				
			></span>
		</v-card-title>
		<v-card-text 
			id 		= "scroll-target"
			class 	= "no-drag overflow-y-auto "			
			:style 	= "{'height': height + 'px'}"
		>
			<!-- :height="height+'px'" -->
			<div
				v-scroll:#scroll-target = "onScroll"
				:height = "height + 'px'"
			>
				
			<v-row
				
			>
				<template v-for = "(item_option, index_option) of analitics_options">
					<v-col 
						:key 	= "index_option"
						xl 	 	= "4"
						lg 	 	= "4"
						md 	 	= "4"
						sm   	= "5"
						xs 		= "12"
						cols 	= "12"
						v-if 	= "item_option.enable"
						class 	= "px-1"
						
					> <!--  card analytic -->
						<v-card 
							outlined 
							height 	  = "100%" 
							min-width = "160px"
						>							
							<v-card-title
								class = "justify-center pa-0 caption grey darken-2 white--text"
							>
								<span 
									class = "ml-2"
								>
									
									{{ item_option.text }}										
								</span>
								<v-spacer></v-spacer>
								<v-icon
									small
									:color = "item_option.status ? 'success' : 'secondary'"
									class  = "ml-3"
								>
									mdi-circle
								</v-icon>
							</v-card-title>							
								<v-card-text 
									class = "d-flex justify-center pa-1 py-0 pt-1"
								>								
									<!-- key == 'motion' || item_option.key == 'objects' -->
									<cam
										v-if 			= "item_option.active"
										:id_stream 		= "info_device.deviceId"
										:show_bar 		= "true"
										:is_analytics   = "index_option"
										:is_channel   	= "item_option.key"
										style 			= "height : 100px;"
									></cam>
								<img 
									v-if  = "!item_option.active"
									:src  = "$logos.login_night"
									style = "width 			: 90%;
											height 			: 90px; 
											padding 		: 5px; 
											margin-top 		: 10px; 
											margin-bottom   : 10px;
											background 		: black"

								>
								<!-- /img/LogoLoginNight.png -->
								
								</v-card-text>									

								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn-toggle
										dense
										v-show = "item_option.active && !loading_option[item_option.key]"
										
									>
										<template
											v-for = "(item_opt, item_opt_index) of options"
											v-if  = "item_opt.enable"
										>
											<v-tooltip bottom>
            									<template v-slot:activator = "{ on }">
													<v-btn
														x-small
														v-if   = "item_opt.type == 'btn'"
														v-show = "!item_opt.hide"
														class  = "pa-0"
														:key   = "item_opt_index"
														v-on   = "on"
														@click = "actions_setting(
															{ 
																option: item_opt.action, // option Analytic
																name: item_option.key // analytic
															}, item_option.container, index_option)"											
														
													>
														<v-icon
															x-small
															:color  = "item_opt.color"
															v-show  = "item_opt.icon "
														>{{item_opt.icon}}</v-icon>
													</v-btn>
												</template>
												<span>
													{{ item_opt.text }}
												</span>
											</v-tooltip>

										
										<!-- btn ext -->
										<v-menu 
      										offset-y 
      										bottom 
      										:close-on-content-click = "true"
      									> 
         								
         								<template 
         									v-slot:activator = " { on: menu } "
         								>

											<v-tooltip bottom>
            									<template v-slot:activator="{ on: tooltip }">
													<v-btn
														x-small
														v-if   = "item_opt.type == 'btn_ext'"
														v-show = "!item_opt.hide"
														class  = "pa-0"
														:key   = "item_opt_index"
														:color = "item_opt.color"
														v-on   = "{...tooltip, ...menu}"
													>
														<v-icon
															x-small
															v-show  = "item_opt.icon "
														>{{item_opt.icon}}</v-icon>
													</v-btn>
												</template>
												<span>
													{{ item_opt.text }}
												</span>
											</v-tooltip>
											</template>
									        <v-list dense>
									            <v-list-item-group dense>
									              <template 
									              	v-for = "(item_sub_opt, sub_index) of options"
									              	v-if  = "item_sub_opt.enable"
									              >
									                
									              <v-list-item               
									                dense
									                v-bind:Key = "sub_index"
									                v-if       = "item_sub_opt && item_sub_opt.text != 'options'"                   
									                @click     = "actions_setting(
															{ 
																option : item_sub_opt.action, // option Analytic
																name 	: item_option.key // analytic
															}, item_option.container, index_option)"
									                
									              >              
									                  <v-list-item-content class="pa-0 ma-0">
									                    <v-list-item-title> {{ item_sub_opt.text }} </v-list-item-title>
									                  </v-list-item-content>
									              </v-list-item>
									              </template>
									            </v-list-item-group>
									          </v-list>
									      </v-menu>   
									    </template>
									</v-btn-toggle>
									<v-btn										
										x-small
										color  ="success"
										v-show = "!item_option.active"
										@click = "actions_setting(
													{ 
														option 	: 'activation',
														name 	: item_option.key
													})"
										
									>
										<v-icon 
											x-small
										>
											mdi-plus
										</v-icon>
									</v-btn>
										<span
											v-show = "!item_option.active"
											class  = "ml-2" 											
											v-text = "$ml.get('activate')"
										></span>
									<v-progress-linear
										indeterminate
										color  = "primary"										
										v-show = "loading_option[item_option.key]"
									></v-progress-linear>
									<v-spacer></v-spacer>

								</v-card-actions>
						</v-card>
					</v-col>
				</template>
			</v-row>
			</div>
		</v-card-text>
			<!-- :set_info="action_to_activate.info" -->
		<activate
			:open_modal 		= "open_activate"
			:info_to_activate 	= "action_to_activate"
			:into_to_license 	= "license"
			@receive_activate 	= "receive_info($event)"

		></activate>
	
	</v-card>
</template>
<script>
	import analytics_default  from '@/components/analytics/analytics_default.json'
	import cam 				  from '@/components/cam_test.vue'
	import EventBus 		  from '@/event-bus'
	import activate 		  from '@/components/stream/activate.vue'
	import license_parameter  from '@/components/analytics/license_parameters.json'
	import options_analytics  from '@/components/analytics/options_analytics.json'
	
	/*{
		"key": "gun",
		"text": "Guns",
		"status" : "",
		"active": false,
		"enable": true,
		"count" : 0
	},
	{
		"key": "person",
		"text": "Persons",
		"status" : "",
		"active": false,
		"enable": true,
		"count" : 0
	}*/

	export default{
		name : 'analytics',
		components : {
			cam,
			activate,						
		},
		props: [
			'layout',
			'layout_id',
			'info_device',
		],
		data: (vm) => ({
			inf 				: {},			
			info_item 			: {},
			analitics_options 	: [], // show actives analytics
			height 				: 250,
			offsetTop 			: 0,
			options 			: options_analytics.options, // options				
			open_activate 		: false,
			action_to_activate 	: {
				action  : '',
				info 	: {},
				name  	: '',
			},
			dialog_analytic		: false,
			info_analytic 		: {},
			license 	 		: license_parameter,
			info_comp 	 		: {},
			hide_options 		: {
				xl : false,
				lg : false,
				md : false,
				sm : false,
				xs : false,

			},
			loading_option 		: options_analytics.tags_boolean,
			ID_notification 	: 'analytics',
			bus					: {
				update_device 			: null,  
				status_container 		: null, 				
				responsive 				: null
			},
			analytics_def  		:  [ ...analytics_default ],
			densitySummary 		: null,
			objectSubgroups 		: null,
			objectHeaders 		: [
				{ text: 'Tipo de Objeto', value: 'type' },
				{ text: 'Cantidad', value: 'count' },
				{ text: 'Densidad', value: 'density' },
				{ text: 'Métricas', value: 'metrics' },
				{ text: 'Hora Pico', value: 'peakTime' }
			]
		}), // data

		watch : {
			
			layout : function(v){
				this.onResize();
			}, //layout

		}, // watch	

		created(){
			this.analitics_options 		= [];			
			let temp_analytics_default 	= [ ...this.analytics_def ];
			
			if (this.info_device && this.info_device.deviceId) {
				this.info_comp 			= this.info_device; 
				this.license.deviceId 	= this.info_device.deviceId;
				let temp_containers 	= this.info_device.container;
				let find 				= false;
				let temp 				= [],
					vm 					= this;

				console.log("temp_containers analitics", temp_containers, temp_analytics_default);
				if (temp_containers && temp_containers.length > 0) {
					/*{
						"key": "motion",
						"text": "Motion",
						"active": false,
						"enable": true,
						"active_dashboard": true,
						"count" : 0
					},*/
					let fnded = false; // check if exist assingment
					temp_containers.forEach((cont, idx_cont) => {
						// console.log("check container analytics : ", cont)
						vm.loading_option[cont.type] = false;
						const fnd = temp_analytics_default.some((def, idx_def)=>{
							if (cont.type.includes(def.key)) {
								fnded 	   = true;
								def.active = true;
								def.status = true;
								def.container = cont;
								def.loading = false;
								// vm.loading_option[def.key] = true; 
								console.log('analitics_options active : ', def.key)
									
								temp.push(def)
								return true;
							}
						})
					});
					if (!fnded && temp_analytics_default && temp_analytics_default.length > 0) {
						temp_analytics_default[0].active = false;
						temp_analytics_default[0].status = false;
					}
				}else{
					console.log("Not found containers actives : ", temp_containers);
					if (temp_analytics_default && temp_analytics_default.length > 0) {

						temp_analytics_default[0].active = false;
						temp_analytics_default[0].status = false;
					}else{
						console.log("Not found containers defaults : ", temp_analytics_default);

					}
				}


				if (find) {
					this.analitics_options =  temp;
				}else{
					console.log("analitics_options ================================")
					temp_analytics_default.forEach((tes)=>{
						console.log( "analitics_options result : ",tes.key, tes.active)
					})
					this.analitics_options  = temp_analytics_default;
				}
			}
		}, // created

		methods:{
			actions_setting(act, item, opt){
				console.log(act, 'send option analytics')
				if (act.option == 'activation') {
					this.open_activate 			 = true;
					this.action_to_activate.name = act.name ;
					this.action_to_activate.info = this.info_comp

				}else{
					

					let option = '/api/v1/';
					const api  = this.$URL + option;
					
					// console.log('play option', act.option , act.name );
					
					if (act.option == 'setting_analytic') { // up to analytics
						// this.dialog_analytic = true;
						let vn 		  = this;
						let list_temp = this.info_comp.container;
						
						// this.dialog_analytic = true;
						this.$Helper.set_local('setting_analytic', { 
							analytic  : act.name,
							container : item, 
							info 	  : this.info_comp } );

						EventBus.$emit("redirect_view", 'setting_analytic');

								// Enabled when its available
						if (list_temp && list_temp.length > 0) {

							const finded = list_temp.some( function (arr_list, arr_idx) {
								if (arr_list.type == act.name) {
									vn.inf_analytic 	 = arr_list;									
									vn.inf_analytic.name = act.name;
									return true
								}
							})
							console.log('finded info analytics', finded);				
						}else{
							console.warn('Not finded info analytics');				

						}
						console.log('info analitic', this.inf_analytic)

					}else{
						this.$emit('recive_analytics', act);
						EventBus.$emit('action_analytic', {
							action : act.option == 'confirm_upgrade' ? 'confirm upgrade' : act.option,
							item,
						});


						if (!item) {
							EventBus.$emit('action_analytic', {
								action : act.option + ': Error : info container not exist',
								color  : 'error'
							});
						}

						if (act.option == 'log') {
							console.log("LOGS  : ", item)
							EventBus.$emit('select_log_container', item);
							EventBus.$emit('set_ref_events', act.name); // for table
						}
						if (act.option == 'start') {

							this.action_container('start', item, act.name);
							EventBus.$emit('select_log_container', item);
							EventBus.$emit('set_ref_events', act.name);
						}
						if (act.option == 'stop') {
							this.action_container('stop', item, act.name);
						}

						if (act.option == 'confirm_upgrade') {
							this.info_item = {
								action : { option : 'upgrade' },
								item,
								act
							};
							EventBus.$emit('notifications_modal', {
								type : 'confirm_upgrade',
								ID   : this.ID_notification 
							})

						}
						if (act.option == 'upgrade') {
							console.log("upgrade");
							this.action_container('upgrade', item, act.name);

						}
					}
				}
			}, // change_state
			
			action_container(act, item, opt){
				console.log("Action container ", act);
				if (item && item.idContainer) {
					this.loading_option[opt] = true;
					let info_send = null;
					const api = this.$URL + '/api/v1/container/' + item.idContainer + '/'+act;
					this.$axios.post(api).then( res =>{
						console.log( "res action container ", act, res);
						info_send = res && res.data ? res.data : res;
						EventBus.$emit('action_analytic', {
							message : info_send
						});
						this.loading_option[opt] = false;
						if (act == 'upgrade') {
							const timer_upgrade = setTimeout(()=>{
								location.reload();
								clearTimeout(timer_upgrade)
							}, 2000)
						}

					}).catch( er => {
						info_send = er && er.message ? er.message : er;
						this.loading_option[opt] = false;						
						EventBus.$emit('action_analytic', {
							message : info_send
						});
						EventBus.$emit('action_analytic', {
							message : "Error request"
						});
						console.log("Error action container ", act, er);
					})
				}else{
					EventBus.$emit('action_analytic', {
						action : 'Error : info container not exist',
						color  : 'error'
					});
				}
			}, // action container

			render_analytics(){
				// let info_local = null;
				// if (localStorage.getItem('Analytics')) {
				// 	info_local = JSON.parse(localStorage.getItem('Analytics'));
				// }else{
				// 	localStorage.setItem('Analytics', JSON.stringify(this.analitics_options));
				// }
			}, // render analytics

			receive_info(val){
					let vm = this;
				if (val.action == 'close') {
					this.open_activate = false;					
				}
				console.log("recive_analytics : ", val)

				// activar analytics / disabled
				if (val.action == 'activate_analytics') {
					const find = vm.analitics_options.some( function(arr_opt, idx_opt){
						if (arr_opt.key == val.activate) {
							arr_opt.active 	= val.opt;
							arr_opt.info 	= val.info;
							return true;
						}
					})
					this.$emit('recive_analytics', {
						option : 'render_analytic',
						info   :  val.info
					});
					if (this.info_comp && this.info_comp.container && this.info_comp.container.length >= 0) {
						this.info_comp.container.push(val.info);
						const info_send = this.info_comp;
						EventBus.$emit("update_device_bus", info_send );
						console.log("INFO DEV COMP : ", this.info_comp);
					}
					/*if (find) {
						this.save_local();
					}*/
				}
			}, //receive_info

			save_local(item){
				if (item && this.analitics_options && this.analitics_options.length > 0) {
					localStorage.setItem('Analytics', JSON.stringify(this.analitics_options));
				}
			}, // save local

			onResize() {
				// console.log(this.height, ' resize analytics')
				if (this.$refs && this.$refs.card && this.$refs.card.$el) {

					this.height = this.$refs.card.$el.clientHeight - 30; // 100					
				}
				
			}, //on Resize
			onScroll (e) {
	        	this.offsetTop = e.target.scrollTop
	     	}, // onScroll

	     	render_status(item){
	     		if (item) {
	     			let ID = item.Id,
	     				state = false,
	     				vm = this; 
	     			if (item.State) {
	     				state = item.State.Running;
	     			}	     			
	     			if (this.analitics_options && this.analitics_options.length > 0){
	     				/*const find = vm.analitics_options.some( (option , idx_option) =>{
	     					if (option && option.container && ID == option.container.idContainer) {
	     						option.active = state;
	     						return true;
	     					}
	     				}); // some*/

	     				let idx = vm.analitics_options.findIndex(x => (x.container &&  x.container.idContainer === ID));
	     				
	     				if (idx >= 0) {
	     					vm.analitics_options[idx].status = state;
	     					
	     				}

	     				console.log("change state analytics : ", idx)
	     			}
	     		}// item

	     	}, // render status
	     	render_hide(show, item, width){
     			let vm 			= this;
     			let list_hide  	= [] ;	     	
     			let show_res 	= false;	
	     		let show_option = true; // for hidden options
	     		if (item) {	     		
	     		
     				if (width > 1547) {
     					show_option = true;
     					show_res 	= false;
     					list_hide.push( 'settings', 'log', 'upgrade'); // ,

     				}
     				if (width < 1547) {
     					show_option = false;
     					show_res 	= true;
     					list_hide.push( 'settings', 'log'); // ,
     				}
     				if (width > 1080 && width < 1300) {
     					show_res 	= true;     		
     					list_hide   = [];
     					list_hide.push('upgrade'); // 'stop'			
     				}
     				if (width < 1080) {
     					show_res 	= true;     		
     					list_hide.push('upgrade'); // 'stop'			
     				}
     				if (width < 805) {
     					show_res 	= true;     		
     					list_hide.push('upgrade'); // 'stop'			
     				}
     				/*if (width > 1080 && width < 1547) {
     					show_res 	= true;     					
     					list_hide.push('upgrade'); // 'stop'			

     				}*/
	     			
	     			// console.log("response : ", show_res, item, width, list_hide)

	     			
	     		}
	     		if (vm.options && vm.options.length > 0) {
	     			let idx_options = vm.options.findIndex( x => (x && x.text == 'options'));
     				if (idx_options >= 0) {
     					vm.options[idx_options].hide = show_option;
     				}
	     			list_hide.forEach((hidden) => {
	     				let idx_option = vm.options.findIndex( x => (x && x.text == hidden) );
	     				// console.log("hide option ", idx_option, show)
	     				if (idx_option >= 0) {
	     					vm.options[idx_option].hide = show_res;
	     				}

	     			})
	     		}
	     	}, // render hide

		}, // methods

		computed:{
			render_analytics_options: function(){
				return this.analitics_options;
			}, // render analytics options

		}, // computed

		mounted(){
			let vm = this;
			vm.$nextTick( ()=>{
				vm.onResize();
			})
			

			EventBus.$on('update_device_to_comp', vm.bus.update_device = (action) => {
				if (action) {
					action.container 	= this.info_comp.container;
					this.info_comp 		= { ...action};

				}
			});
			
			EventBus.$on('status_container', vm.bus.status_container = (action)=>{
				if (action) {
					this.render_status(action);
				}
			});
			let temp_noti 	  = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp_noti, vm.bus[temp_noti] = (action) => {
				if (action) {
					if (this.info_item) {

						let { action , item, act } = this.info_item;

						this.actions_setting(action, item, act)
					}else{
						console.log("Not found info to delete in analytics ");
					}
				}else{
					this.info_item = {};
				}
			});

			let create_resp   = false;
			EventBus.$on('responsive', vm.bus.responsive = (size) => {
				// console.log("responsive : ",size)


				if (size) {
					// true for hide / false for show
				
					if (!create_resp) {
						this.render_hide(true, size.size, size.width );
						create_resp = true;
					}

					//  setting , log
					if (size.width < 1547 && size.size == 'lg') { //lg 1362
						this.render_hide(true, size.size, size.width );

					} 

					//  setting , log
					if(size.width > 1362 && ['lg', 'xl'].includes(size.size)){
						this.render_hide(false,  size.size, size.width );
						
					}
					//  upgrade
					if(size.width  < 805 && size.size == 'sm'){
						this.render_hide(true, size.size, size.width );
					}
					// upgrade
					if(size.width  > 805  && size.width  < 1362 &&  size.size == 'md'){
						this.render_hide(true, size.size, size.width );
					}
					/*if(size.width  > 805 && size.width  < 1362 && (size.size == 'sm' || size.size == 'md')){
						this.render_hide(false, size.size, size.width );
					}*/
					// 1030 / md
				}
			}); // responsive

		}, // mounted

		beforeDestroy(){
			this.analitics_options 	= [];		
			analytics_default.forEach((tes)=>{
				if (tes.active) {
					tes.active = false;
				}
				console.log( "analitics_options result : ",tes.key, tes.active)
			})	
			let vm 					= this;
			if (vm.bus) {
				console.log("close bus analytics ",vm.bus)
				for(let iter in vm.bus){
					if (vm.bus[iter]) {
						EventBus.$off(iter, vm.bus[iter]);

					}
				}
			}
		}, // beforeDestroy
	};
</script>